// import React from "react";
import React, { useState } from "react";
import { Navbar, Nav, NavDropdown, Container, Button } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";

const MainNavbar = () => {
  const [expanded, setExpanded] = useState(false);
  return (
    <Navbar expand="lg" fixed="top" expanded={expanded} className="custom-navbar" variant="dark">
      <Container>

        {/* Logo / Brand */}
        <Navbar.Brand as={Link} to="/" className="brand-logo">
          <img
            src="/images/img/Logo.png"
            alt="Hindustan Agro Life Logo"
            className="logo-img"
          />
          <div className="brand-text-wrap">
            <span className="brand-title">Hindustan</span>
            <span className="brand-subtitle">Agro Life</span>
          </div>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-nav" onClick={() => setExpanded(expanded ? false : "expanded")} />

        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto align-items-center">

            <Nav.Link
              as={NavLink}
              to="/"
              end
              className="nav-link-custom"
              onClick={() => setExpanded(false)}
            >
              Home
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              to="/about"
              className="nav-link-custom"
              onClick={() => setExpanded(false)}
            >
              About
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              to="/products"
              className="nav-link-custom"
              onClick={() => setExpanded(false)}
            >
              Products
            </Nav.Link>

            <NavDropdown
              title="Categories"
              id="categories-dropdown"
              className="nav-dropdown-custom"
              align="end"
            >
              <NavDropdown.Item
                as={Link}
                to="/category/insecticides"
                onClick={() => setExpanded(false)}
              >
                Insecticides
              </NavDropdown.Item>

              <NavDropdown.Item
                as={Link}
                to="/category/fungicides"
                onClick={() => setExpanded(false)}
              >
                Fungicides
              </NavDropdown.Item>

              <NavDropdown.Item
                as={Link}
                to="/category/herbicides"
                onClick={() => setExpanded(false)}
              >
                Herbicides
              </NavDropdown.Item>

              <NavDropdown.Item
                as={Link}
                to="/category/fertilizers"
                onClick={() => setExpanded(false)}
              >
                Fertilizers
              </NavDropdown.Item>

              <NavDropdown.Item
                as={Link}
                to="/category/plant-growth-regulators"
                onClick={() => setExpanded(false)}
              >
                Plant Growth Regulators
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/category/NPK-Fertilizer"
                onClick={() => setExpanded(false)}
              >
                NPK Fertilizer
              </NavDropdown.Item>
            </NavDropdown>

            {/* Contact Button */}
            <Button
              as={Link}
              to="/contact"
              className="contact-btn ms-lg-3 mt-3 mt-lg-0"
              onClick={() => setExpanded(false)}
            >
              Contact
            </Button>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MainNavbar;
